export const osVectorLayerId = 1;
export const osVectorLayerTitle = "OS Vector";

export const osRoadLayerId = 2;
export const osRoadLayerTitle = "OS Road";

export const satelliteLayerId = 3
export const satelliteLayerTitle = "Satellite Map"; 